export function initRebatesList() {
    $('.show-rebates').click(function (e) {
        e.preventDefault();
        var $self = $(this);
        var $banners = $self.closest('.rebates-list').find('.banner-wrapper');

        if ($self.attr('data-expanded') === 'true') {
            $banners.not(':first-of-type').addClass('d-none');
            $self.attr('data-expanded', 'false').text('Show More Rebates');
        } else {
            $banners.removeClass('d-none');
            $self.attr('data-expanded', 'true').text('Show Less Rebates');
        }
    });
}
